import { createLayerCanvas, toDataUrl } from './canvasUtils'
import { extractLandmarkFeatures } from './extractLandmarkFeatures'

export const buildEarsLayer = ({ landmarks, width, height, features = null }) => {
  if (!landmarks?.length) return null
  const featureMap = features || extractLandmarkFeatures({ landmarks, width, height })
  const leftEar = featureMap?.ears?.left || null
  const rightEar = featureMap?.ears?.right || null
  const baseDist = featureMap?.eyes?.distance || Math.min(width, height) * 0.3
  if (!leftEar && !rightEar) return null

  const { canvas, ctx } = createLayerCanvas(width, height)
  ctx.fillStyle = 'rgba(244, 114, 182, 0.44)'
  ctx.strokeStyle = 'rgba(244, 114, 182, 0.85)'
  ctx.lineWidth = Math.max(1.2, baseDist * 0.01)

  const drawEar = (ear) => {
    if (!ear?.center) return
    ctx.beginPath()
    ctx.ellipse(ear.center.x, ear.center.y, ear.radiusX, ear.radiusY, 0, 0, Math.PI * 2)
    ctx.fill()
    ctx.stroke()
  }

  drawEar(leftEar)
  drawEar(rightEar)
  return toDataUrl(canvas)
}
